import { Upload, X } from "lucide-react";
import { useRef, useState } from "react";
import { Button, TextField, ToggleField } from "@/components/ui";

export function FileUploadPanel({ onUpload }: { onUpload: (path: string, file: File, ingest: boolean) => Promise<unknown> }) {
  const [path, setPath] = useState("");
  const [ingest, setIngest] = useState(true);
  const [file, setFile] = useState<File | null>(null);
  const fileInput = useRef<HTMLInputElement>(null);

  const clearFile = () => {
    setFile(null);
    // Resetting state is not enough: the native control keeps rendering the
    // filename until its own value is cleared. Clearing it also means picking
    // the same file again still fires change.
    if (fileInput.current) fileInput.current.value = "";
  };

  return (
    <div className="flex flex-wrap items-end gap-2.5">
      <TextField className="flex-[1_1_420px]" label="R2 path" value={path} onChange={setPath} placeholder="skills/travel-budget/SKILL.md" />
      <ToggleField label="Add searchable file types to OpenSearch" checked={ingest} onChange={setIngest} />
      {/* Tighter gap than the row's: the clear button belongs to the input
          next to it, not to the row's sequence of controls. */}
      <div className="flex items-center gap-1">
        {/* Preflight strips ::file-selector-button down to borderless, padless,
            transparent text, so the native chooser reads as a bare label. These
            file: utilities rebuild it with Button's outline variant values —
            same radius, border, padding and hover as every other button here.
            Styling the pseudo-element rather than hiding the input keeps the
            browser's own, localized "no file selected" text. */}
        <input
          ref={fileInput}
          type="file"
          className="cursor-pointer text-xs text-muted-foreground file:mr-2.5 file:cursor-pointer file:rounded-lg file:border file:border-border file:bg-transparent file:px-3.25 file:py-2.25 file:text-sm file:text-foreground file:transition-colors file:hover:bg-muted"
          onChange={(event) => setFile(event.target.files?.[0] || null)}
        />
        {file && (
          <Button variant="ghost" size="icon" onClick={clearFile} aria-label="Clear selected file" title="Clear selected file">
            <X />
          </Button>
        )}
      </div>
      <Button disabled={!path || !file} onClick={() => file && onUpload(path, file, ingest)}>
        <Upload /> Upload
      </Button>
    </div>
  );
}
